/**
 * Mutex class for JS based on Promises.
 *
 * Used for calling asynchronous processes synchronously.
 * Example.: Long API call, that can be cached, but would be called multiple times in parallel
 *
 * @credit https://github.com/mgtitimoli/await-mutex/
 */
export default class Mutex {
  constructor() {
    this._locking = Promise.resolve();
    this._locks = 0;
  }

  isLocked() {
    return this._locks > 0;
  }

  /**
   * Locks mutex and returns function for unlocking it
   *
   * @returns {function}
   */
  lock() {
    this._locks += 1;

    let unlockNext;
    const willLock = new Promise(
      /* eslint-disable-next-line no-return-assign */
      resolve => {
        unlockNext = () => {
          this._locks -= 1;
          resolve();
        };
      },
    );

    const willUnlock = this._locking.then(() => unlockNext);
    this._locking = this._locking.then(() => willLock);

    return willUnlock;
  }
}
